_ = require 'underscore'
Controller = require 'controller'
l = require 'lib/localize'
Enterprise = require 'models/enterprise'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
View = require 'view'
log = require 'debug/log'
template = require 'views/templates/header_enterprise_admin_dashboard_menu'

module.exports = class HeaderEnterpriseAdminDashboardMenuView extends View
  # TODO: localize
  getViewTitle: -> "Trello Enterprise"

  initialize: ->
    Promise.map @model.get('idEnterprisesAdmin'), (id) =>
      Enterprise.load id, Payloads.enterpriseMinimum, @modelCache
    .then (result) =>
      @enterprises = result
      @render()

  render: ->
    log('render', "rendering HeaderEnterpriseAdminDashboardMenuView")

    if @enterprises?
      if @enterprises.length > 0
        links = _.map @enterprises, (e) =>
          title: e.get('displayName')
          url: Controller.getEnterpriseAdminDashboardUrl e.get('id')
        @$el.html template links
      else
        @$el.text "You are not an admin of any enterprise"
    else
      @$el.text "Loading..."

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-enterprise-admin-dashboard-menu-view.coffee